module.exports = __webpack_public_path__ + "static/media/localFileIcon.eab6d1cc.svg";